import { DialogContent } from '@mui/material';

import {
  BaseRequiredDialogProps,
  DialogDraggable,
} from '@bloomfieldrobotics/canopy';
import { Shell } from './Shell';

export const DuckDBShellDialog = ({
  open: isOpen,
  onClose,
}: BaseRequiredDialogProps) => {
  return (
    <DialogDraggable
      fullWidth
      title={'DuckDB Shell'}
      open={isOpen}
      onClose={onClose}
    >
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'scroll',
        }}
      >
        <Shell />
      </DialogContent>
    </DialogDraggable>
  );
};
